<template>
  <div class="loader-wrapper">
    <span class="loader"></span>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.loader-wrapper {
  width: 100vw;
  height: calc(var(--vh) * 100);
  background-color: var(--black-100);
  z-index: 1;
}
.loader {
  font-size: 10px;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  text-indent: -9999em;
  animation: mulShdSpin 1.1s infinite ease;
  transform: translateX(-50%) translateY(-50%) translateZ(0);
}
@keyframes mulShdSpin {
  0%,
  100% {
    box-shadow: 0em -2.6em 0em 0em var(--primary-yellow),
      1.8em -1.8em 0 0em rgba(255, 213, 0, 0.2), 
      2.5em 0em 0 0em rgba(255, 213, 0, 0.2),
      1.75em 1.75em 0 0em rgba(255, 213, 0, 0.2),
      0em 2.5em 0 0em rgba(255, 213, 0, 0.2),
      -1.8em 1.8em 0 0em rgba(255, 213, 0, 0.2),
      -2.6em 0em 0 0em rgba(255, 213, 0, 0.5),
      -1.8em -1.8em 0 0em rgba(255, 213, 0, 0.7);
  }
  12.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(255, 213, 0, 0.7),
      1.8em -1.8em 0 0em var(--primary-yellow),
      2.5em 0em 0 0em rgba(255, 213, 0, 0.2),
      1.75em 1.75em 0 0em rgba(255, 213, 0, 0.2),
      0em 2.5em 0 0em rgba(255, 213, 0, 0.2),
      -1.8em 1.8em 0 0em rgba(255, 213, 0, 0.2),
      -2.6em 0em 0 0em rgba(255, 213, 0, 0.2),
      -1.8em -1.8em 0 0em rgba(255, 213, 0, 0.5);
  }
  25% {
    box-shadow: 0em -2.6em 0em 0em rgba(255, 213, 0, 0.5),
      1.8em -1.8em 0 0em rgba(255, 213, 0, 0.7),
      2.5em 0em 0 0em var(--primary-yellow),
      1.75em 1.75em 0 0em rgba(255, 213, 0, 0.2),
      0em 2.5em 0 0em rgba(255, 213, 0, 0.2),
      -1.8em 1.8em 0 0em rgba(255, 213, 0, 0.2),
      -2.6em 0em 0 0em rgba(255, 213, 0, 0.2),
      -1.8em -1.8em 0 0em rgba(255, 213, 0, 0.2);
  }
  37.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(255, 213, 0, 0.2),
      1.8em -1.8em 0 0em rgba(255, 213, 0, 0.5),
      2.5em 0em 0 0em rgba(255, 213, 0, 0.7),
      1.75em 1.75em 0 0em var(--primary-yellow),
      0em 2.5em 0 0em rgba(255, 213, 0, 0.2),
      -1.8em 1.8em 0 0em rgba(255, 213, 0, 0.2),
      -2.6em 0em 0 0em rgba(255, 213, 0, 0.2),
      -1.8em -1.8em 0 0em rgba(255, 213, 0, 0.2);
  }
  50% {
    box-shadow: 0em -2.6em 0em 0em rgba(255, 213, 0, 0.2),
      1.8em -1.8em 0 0em rgba(255, 213, 0, 0.2),
      2.5em 0em 0 0em rgba(255, 213, 0, 0.5),
      1.75em 1.75em 0 0em rgba(255, 213, 0, 0.7),
      0em 2.5em 0 0em var(--primary-yellow),
      -1.8em 1.8em 0 0em rgba(255, 213, 0, 0.2),
      -2.6em 0em 0 0em rgba(255, 213, 0, 0.2),
      -1.8em -1.8em 0 0em rgba(255, 213, 0, 0.2);
  }
  62.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(255, 213, 0, 0.2),
      1.8em -1.8em 0 0em rgba(255, 213, 0, 0.2),
      2.5em 0em 0 0em rgba(255, 213, 0, 0.2),
      1.75em 1.75em 0 0em rgba(255, 213, 0, 0.5),
      0em 2.5em 0 0em rgba(255, 213, 0, 0.7),
      -1.8em 1.8em 0 0em var(--primary-yellow),
      -2.6em 0em 0 0em rgba(255, 213, 0, 0.2),
      -1.8em -1.8em 0 0em rgba(255, 213, 0, 0.2);
  }
  75% {
    box-shadow: 0em -2.6em 0em 0em rgba(255, 213, 0, 0.2),
      1.8em -1.8em 0 0em rgba(255, 213, 0, 0.2),
      2.5em 0em 0 0em rgba(255, 213, 0, 0.2),
      1.75em 1.75em 0 0em rgba(255, 213, 0, 0.2),
      0em 2.5em 0 0em rgba(255, 213, 0, 0.5),
      -1.8em 1.8em 0 0em rgba(255, 213, 0, 0.7),
      -2.6em 0em 0 0em var(--primary-yellow),
      -1.8em -1.8em 0 0em rgba(255, 213, 0, 0.2);
  }
  87.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(255, 213, 0, 0.2),
      1.8em -1.8em 0 0em rgba(255, 213, 0, 0.2),
      2.5em 0em 0 0em rgba(255, 213, 0, 0.2),
      1.75em 1.75em 0 0em rgba(255, 213, 0, 0.2),
      0em 2.5em 0 0em rgba(255, 213, 0, 0.2),
      -1.8em 1.8em 0 0em rgba(255, 213, 0, 0.5),
      -2.6em 0em 0 0em rgba(255, 213, 0, 0.7),
      -1.8em -1.8em 0 0em var(--primary-yellow);
  }
}
</style>
